<template>
  <div class="card-body shade">
    <!-- Title, date, top edit button -->
    <div class="container-fluid row">
      <div v-if="event.isUpcoming()" class="col-3 d-flex-no-mobile">
        <router-link :to="editEventLink" class="btn btn-primary align-self-center mb-4">
          <h4 class="mb-1 light-weight">Edit Event</h4>
        </router-link>
      </div>
      <div class="col mr-3">
        <h3 class="card-title light-weight my-3 display-4 text-right">{{ event.title }}</h3>
        <h5 class="card-subtitle text-muted mb-4 ultra-light-weight text-right">{{ dateString }}</h5>
      </div>
    </div>

    <!-- Event image -->
    <img class="card-img event-img" :src="event.photoUrl">

    <!-- Description -->
    <div class="m-4" v-html="event.htmlDescription ? event.htmlDescription : event.description"></div>

    <!-- Bottom edit button -->
    <router-link v-if="event.isUpcoming()" :to="editEventLink" class="btn btn-primary d-mobile mb-4">
      <h4 class="mb-1 light-weight">Edit Event</h4>
    </router-link>

    <!-- Number of registered users -->
    <div v-if="event.numRegistered > 0" :class="css.dataFieldContainer">
      <div :class="css.dataField">
        <h4 class="ml-3 mid-weight">Registered users: </h4>
      </div>
      <div :class="css.dataField">
        <h4 class="ml-3 light-weight">
          {{ event.numRegistered }}
          {{ `${event.capacity ? '&nbsp; Out of ' + event.capacity : ''}` }}
        </h4>
      </div>
    </div>

    <!-- Number of interested users -->
    <div v-if="numInterested > 0" :class="css.dataFieldContainer">
      <div :class="css.dataField">
        <h4 class="ml-3 mid-weight">Interested users: </h4>
      </div>
      <div :class="css.dataField">
        <h4 class="ml-3 light-weight">{{ numInterested }}</h4>
      </div>
    </div>

    <!-- Revenue -->
    <div v-if="revenue > 0" :class="css.dataFieldContainer">
      <div :class="css.dataField">
        <h4 class="ml-3 mid-weight">{{ event.isUpcoming() ? 'Current ' : '' }} Revenue: </h4>
      </div>
      <div :class="css.dataField">
        <h4 class="ml-3 light-weight">{{ revenueString }}</h4>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from '../store'

export default {
  props: {
    eventId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      css: {
        dataField: 'col-lg-3 col-md-6 col-sm-12',
        dataFieldContainer: 'row mb-4 align-items-center'
      }
    }
  },
  computed: {
    event () {
      // Its bad practice to store a custom type as data for a Vue instance
      // https://github.com/vuejs/vue/issues/2718
      // So we make a computed property that returns the Event in Store.events
      // and provide mock data for when this gets called before eventId is
      // properly set, so as to silence errors
      if (this.eventId) {
        return Store.events[this.eventId]
      } else {
        return {
          isUpcoming: () => false,
          date: new Date(),
          interestedUsers: {}
        }
      }
    },
    editEventLink () {
      return this.$route.path + '/edit'
    },
    dateString () {
      const eventDate = this.event.date

      const [day, month, date, year] = [
        { weekday: 'long' }, { month: 'long' }, { day: 'numeric' }, { year: 'numeric' }
      ].map(opts => eventDate.toLocaleString('en-us', opts))

      return `${day}, ${month} ${date} ${year}`
    },
    numInterested () {
      return Object.keys(this.event.interestedUsers).length
    },
    revenue () {
      return this.event.donation
        ? this.calcDonationRevenue()
        : this.calcPriceRevenue()
    },
    revenueString () {
      return '$' + this.revenue.toFixed(2)
    }
  },
  methods: {
    calcDonationRevenue () {
      let donations = this.event.donationAmounts
      let total = 0
      for (let registeredUser in donations) {
        if (!donations.hasOwnProperty(registeredUser)) continue
        total += donations[registeredUser]
      }
      return total
    },
    calcPriceRevenue () {
      return this.event.price * this.event.numRegistered
    }

  }
}
</script>

<style scoped>
.event-img {
  max-width: 800px;
  display: block;
  margin: auto;
}

.d-flex-no-mobile {
  display: flex;
}

@media only screen and (max-width: 767px) {
  .d-flex-no-mobile {
    display: none;
  }

  .d-mobile {
    display: block;
  }
}

/*
These sizes (768 and 767) come from Bootstrap's definitions of col-md (>= 768px). See:
https://getbootstrap.com/docs/4.0/layout/grid/#grid-options
*/
@media only screen and (min-width: 768px) {
  .d-mobile {
    display: none;
  }
}
</style>
